<template>
    <div class="container mx-auto mx-md-4" style="font-size: 1.5rem;">
        <header class="mb-4">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <a href="/">
                            <img src="/images/logo.png" width="280px" alt="">
                        </a>
                    </div>
                    <div class="col d-inline-flex align-items-center justify-content-center" style="font-size: 1.5rem;">
                        {{ interactiveInterfaceTitle }}
                    </div>
                    <div class="col d-inline-flex align-items-center justify-content-end" style="font-size: 1.5rem;" v-if="user.fingerprint">
                        <div>{{ user.nickname }}</div>
                    </div>
                </div>
            </div>
        </header>

        <div v-if="interactiveInterface.is_before_start">
            <div class="col-12 text-center mb-5" style="font-size: 120%;">
                A(z) {{ interactiveInterface.type_name }} majd <span class="font-weight-bold">{{ interactiveInterface.fill_start_at }}</span> időpont után lesz elérhető!
            </div>
        </div>
        <div v-else-if="interactiveInterface.is_after_end">
            <div class="col-12 text-center mb-5" style="font-size: 120%;">
                A(z) {{ interactiveInterface.type_name }} <span class="font-weight-bold">{{ interactiveInterface.fill_end_at }}</span> időpontban véget ért!
            </div>
        </div>
        <div v-else>
            <template v-if="user.step === 0">
                <Registration
                    @registered="user = $event; nextStep()"
                />
            </template>
            <template v-if="user.step === 1">
                <StartGame
                    :user="user"
                    @next="nextStep"
                />
            </template>
            <template v-if="user.step === 2">
                <Game
                    @next="nextStep"
                    @close="closeGame"
                />
            </template>
            <template v-if="user.step === 3">
                <div>
                    <Thanks />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Registration from "./Registration.vue";
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie'
import StartGame from "./StartGame";
import Game from "./Game";
import Thanks from "./Thanks";

export default {
    components: {
        Thanks,
        StartGame,
        Registration,
        Game,
    },
    data() {
        return {
            user: {
                fingerprint: null,
                step: 0,
            },
            interactiveInterface: null,
        }
    },
    computed: {
        interactiveInterfaceTitle() {
            return window.InteractiveInterfaceTitle;
        }
    },
    created() {
        this.makeUser();

        this.interactiveInterface = window.InteractiveInterface;
    },
    methods: {
        getUrlPrefix() {
            return `/interactive-interface/${window.InteractiveInterfaceCategorySlug}/${window.InteractiveInterfaceSlug}`;
        },
        async makeUser() {
            let fingerprint = Cookies.get('fingerprint');
            this.user.fingerprint = fingerprint;

            if (!fingerprint) {
                fingerprint = this.generateFingerprint();
            }

            await axios.get(`${this.getUrlPrefix()}/user/${fingerprint}`).then((response) => {
                this.user = response.data;
            });
        },
        generateFingerprint() {
            this.user.fingerprint = uuidv4();
            Cookies.set('fingerprint', this.user.fingerprint);

            return this.user.fingerprint;
        },
        async nextStep() {
            await axios.post(`${this.getUrlPrefix()}/next-step`, {
                fingerprint: this.user.fingerprint,
            }).then((response) => {
                this.user = response.data;
            });
        },
        closeGame() {
            axios.post(`${this.getUrlPrefix()}/close-game`, {
                fingerprint: this.user.fingerprint,
            }).then((response) => {
                this.user = response.data.user;
            });
        }
    }
}
</script>
